import {Contract} from 'ethers';
import {createContext, ReactNode, useContext} from 'react';

const GameContractContext = createContext<Contract>({} as Contract);

export function GameContractProvider({
  contract,
  children,
}: {
  contract: Contract | null;
  children: ReactNode;
}) {
  return (
    <GameContractContext.Provider value={contract || ({} as Contract)}>
      {contract ? children : null}
    </GameContractContext.Provider>
  );
}

export function useGameContract() {
  return useContext(GameContractContext);
}
